import { ChangeEventHandler, useEffect, useState } from 'react';
import {
  Grid, Paper, Stack, TextField, Typography,
} from '@mui/material';
import { v4 as uuid } from 'uuid';
import BlockProps from '../../../models/BlockProps';
import BlockiFrameSafeData from './BlockiFrameSafeData';
import CloseButton from '../../Buttons/Close';
import EditableText from '../../Form/EditableText';
import Utils from '../../../utils/Utils';
import { stripScripts, containsJavaScript } from '../../../utils/htmlSanitization';

function BlockiFrameSafe({
  data, isEditing, isTemplate, editHandler,
}: BlockProps) {
  const props = (data.data as BlockiFrameSafeData);
  const [validationError, setValidationError] = useState<string | null>(null);

  useEffect(() => {
    if (props.html?.value && containsJavaScript(props.html.value)) {
      setValidationError('JavaScriptは許可されていません。scriptタグ、イベント属性(onclick等)、javascript:は使用できません。');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleHtml: ChangeEventHandler<HTMLInputElement> = (event) => {
    props.html.value = stripScripts(event.target.value);
  };

  const handleBlur: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => {
    const { value } = event.target;
    const sanitized = stripScripts(value);
    props.html.value = sanitized;

    if (containsJavaScript(value)) {
      setValidationError('JavaScriptが検出されたため、自動的に削除されました。');
      setTimeout(() => setValidationError(null), 3000);
    } else {
      setValidationError(null);
    }

    editHandler(data.id, props);
  };

  const sanitizedHtml = props.html?.value ? stripScripts(props.html.value) : '';

  return (
    <Stack
      spacing={0}
      style={{
        overflow: 'hidden',
      }}
    >
      {(isEditing && !isTemplate) && (
        <Stack spacing={0} sx={{ border: '1px dashed lightGray', p: 2, m: 2 }}>
          <TextField
            key={uuid()}
            label="埋め込みiFrame"
            multiline
            rows={4}
            defaultValue={props.html?.value}
            onChange={handleHtml}
            onBlur={handleBlur}
          />
          {validationError && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {validationError}
            </Typography>
          )}
        </Stack>
      )}
      <Grid
        container
        direction="column"
        sx={{
          justifyContent: 'center', alignItems: 'center', p: 2,
        }}
      >
        {sanitizedHtml && (
          <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
        )}
        {!sanitizedHtml && (
          <Paper
            elevation={0}
            sx={{
              width: '100%', height: 450, background: '#F4F4F6', border: '1px dashed lightGray',
            }}
          />
        )}
        {props.text && (
          <Grid item sx={[Utils.hoverBorder(isEditing), { marginTop: 2 }]}>
            {isEditing && (
              <CloseButton updateHandler={() => {
                props.text = undefined;
                editHandler(data.id, props);
              }}
              />
            )}
            <EditableText
              text={props.text?.value}
              isEditable={isEditing && !isTemplate}
              updateHandler={(newText) => {
                props.text.value = newText;
                editHandler(data.id, props);
              }}
            />
          </Grid>
        )}
      </Grid>
    </Stack>
  );
}

export default BlockiFrameSafe;
